export default __webpack_public_path__ + "static/media/Asset3.44df4d92.svg";